import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { data } from '../../evn/evn'; // Adjust path as needed
import Sidebar from '../AdminComponents/SideBar';
import styles from './CaseDetailsManagement.module.css'; // Make sure the path matches your CSS file structure

const CaseDetailsManagement = () => {
  const [caseDetails, setCaseDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchType, setSearchType] = useState('id');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCaseDetails = async () => {
      const ip = data.evn; // Ensure the correct variable name is used
      const token = localStorage.getItem('adminToken');
      if (!token) {
        navigate('/.admin');
        return false;
    }
      

      try {
        const response = await axios.get(`${ip}/admin/case-details`, {
          headers: { 'x-auth-token': token },
        });
        setCaseDetails(response.data.caseDetails);
        setSearchResults(response.data.caseDetails);
      } catch (error) {
        console.error("There was an error fetching the case details:", error);
      }
    };

    fetchCaseDetails();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    if (!event.target.value) {
      setSearchResults(caseDetails);
    } else {
      const filteredCaseDetails = caseDetails.filter(detail => {
        switch (searchType) {
          case 'id':
            return detail.id.toString().includes(event.target.value);
          case 'userId':
            return detail.user_id.toString().includes(event.target.value);
          case 'caseId':
            return detail.case_id.toString().includes(event.target.value);
          default:
            return true;
        }
      });
      setSearchResults(filteredCaseDetails);
    }
  };

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSearchTerm('');
    setSearchResults(caseDetails);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && searchTerm) {
      const exactMatchDetails = caseDetails.filter(detail => {
        switch (searchType) {
          case 'id':
            return detail.id.toString() === searchTerm;
          case 'userId':
            return detail.user_id.toString() === searchTerm;
          case 'caseId':
            return detail.case_id.toString() === searchTerm;
          default:
            return false;
        }
      });
      setSearchResults(exactMatchDetails);
    }
  };

  return (
    <>
      <Sidebar />
      <div className={styles.container}>
        <div className={styles.searchContainer}>
          <select
            className={styles.searchTypeSelect}
            value={searchType}
            onChange={handleSearchTypeChange}
          >
            <option value="id">Search by ID</option>
            <option value="userId">Search by User ID</option>
            <option value="caseId">Search by Case ID</option>
          </select>
          <input
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            className={styles.searchInput}
          />
        </div>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableRow}>
              <th className={styles.tableHeader}>ID</th>
              <th className={styles.tableHeader}>User ID</th>
              <th className={styles.tableHeader}>Case ID</th>
              <th className={styles.tableHeader}>Client</th>
              <th className={styles.tableHeader}>Team</th>
              <th className={styles.tableHeader}>Type</th>
              <th className={styles.tableHeader}>Lawyer Type</th>
              
            </tr>
          </thead>
          <tbody>
            {searchResults.map((detail) => (
              <tr key={detail.id} className={styles.tableRow}>
                <td className={styles.tableCell}>{detail.id}</td>
                <td className={styles.tableCell}>{detail.user_id}</td>
                <td className={styles.tableCell}>{detail.case_id}</td>
                <td className={styles.tableCell}>{detail.client}</td>
                <td className={styles.tableCell}>{detail.team}</td>
                <td className={styles.tableCell}>{detail.type}</td>
                <td className={styles.tableCell}>{detail.lawyerType}</td>
                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CaseDetailsManagement;
